/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAllBeneficiariesData } from "../../../services/beneficiaries";
//import PlusCircle from "@assets/plus-circle.png";
import BeneficiarySkeleton from "@/components/Common/Skeletons/BeneficiarySkeleton";
import Wizard from "@/components/Wizard";
import { isEnrolledStatus } from "@/types/employeeState";
import { displayUSDateFormat } from "@/utils/dayjs";
import { formatRelationshipKeys } from "@/utils/generalUtilities";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { clearSelectedBeneficiary } from "../../../store/beneficiarySlice";

interface BeneficiaryType {
  minorAccountID: string;
  name: string;
  relationship: string;
  dateOfBirth: string;
}

const BeneficiarySettings: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const [loading, setLoading] = useState<boolean>(true);
  const [beneficiaries, setBeneficiaries] = useState<BeneficiaryType[]>([]);
  const [isAddBeneficiaryModalOpen, setIsAddBeneficiaryModalOpen] =
    useState(false);

  const handleFetchBeneficiaries = async () => {
    setLoading(true);
    try {
      dispatch(clearSelectedBeneficiary());
      // const response = await getAllBeneficiaries();

      const response = await getAllBeneficiariesData(user.employeeID, user.id);

      const filteredBeneficiaries = response.data.filter((benefiicary: any) =>
        isEnrolledStatus(benefiicary.minorEnrolledStatus),
      );

      if (filteredBeneficiaries.length > 0) {
        const beneficiariesData = filteredBeneficiaries?.map(
          (beneficiary: any) => ({
            minorAccountID: beneficiary.minorAccountID,
            name: `${beneficiary.firstName} ${beneficiary.lastName}`,
            relationship: beneficiary.relationship,
            dateOfBirth: beneficiary.dateOfBirth,
          }),
        );

        setBeneficiaries(beneficiariesData);
      }
    } finally {
      setLoading(false);
    }
  };

  /*   const handleAddBeneficiary = () => {
    setIsAddBeneficiaryModalOpen(true);
  }; */

  useEffect(() => {
    handleFetchBeneficiaries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <BeneficiarySkeleton count={2} />
      ) : (
        <>
          {isAddBeneficiaryModalOpen && (
            <Wizard
              modal={true}
              setIsModalOpen={setIsAddBeneficiaryModalOpen}
              isUserEnrolled={true}
              onCancel={() => setIsAddBeneficiaryModalOpen(false)}
            />
          )}

          {beneficiaries && beneficiaries.length > 0 ? (
            <>
              {beneficiaries.map((beneficiary: BeneficiaryType) => (
                <div key={beneficiary.minorAccountID}>
                  <div className="p-[32px]">
                    <p className="text-lg font-semibold">{beneficiary.name}</p>
                    <div className="flex justify-between mt-2 text-black">
                      <div>
                        <p>
                          {t("savings_settings.beneficiaries.relationship")}
                        </p>
                        <p>{t("savings_settings.beneficiaries.birth_date")}</p>
                      </div>
                      <div>
                        <p className="mt-1">
                          {formatRelationshipKeys(beneficiary.relationship)}
                        </p>
                        <p className="mt-1">
                          {displayUSDateFormat(beneficiary.dateOfBirth)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              ))}

              {/* Temporararily hiding this */}
              {/*  <div className="px-[16px] py-[32px] md:p-[32px]">
                <button
                  data-testid="add-beneficiary-btn"
                  onClick={handleAddBeneficiary}
                  className="text-[#00ADAC] h-[24px] flex items-center space-x-2"
                >
                  <img
                    className="w-[24px] h-[22px]"
                    src={PlusCircle}
                    alt="Plus"
                  />
                  <p>Add Beneficiary #{beneficiaries.length + 1}</p>
                </button>
              </div> */}
            </>
          ) : (
            <>
              <p className="p-4 mb-2 text-[18px] font-normal">
                {t("savings_settings.beneficiaries.no_beneficiaries")}
              </p>
            </>
          )}
        </>
      )}
    </>
  );
};

export default BeneficiarySettings;
